import React, { useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  Backdrop,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CloseSharp } from "@mui/icons-material";
import recipienticon from "../../assets/images/recipient-name.png";
import recipientemailicon from "../../assets/images/email-icon-pod.png";
import deliverydateicon from "../../assets/images/delivery-date-pod.png";
import deliverytimeicon from "../../assets/images/deliverytime-pod-icon.png";
import podloc1icon from "../../assets/images/pod-location1-icon.png";
import podloc2icon from "../../assets/images/pod-loc2-icon.png";
import { toLocalTime } from "../../helper/functions";
import PodMap from "../../components/maps/PodMap";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)", // Adjust blur strength as needed
  },
  dialogPaper: {
    borderRadius: "0", // Set border radius to 0
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important", // Adding !important to ensure the color overrides
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Initial outlined border color
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color when focused
      },
    },
  },
}));
const PickupProofModal = ({ pickup }) => {
  const [openModal, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        sx={{
          backgroundColor: "#683C8C !important",
          fontSize: "12px",
          fontWeight: 700,
          textTransform: "none",
          borderRadius: "12px",
          position: "absolute",
          mt: "10px",
        }}
      >
        Pickup Proof
      </Button>
      <Backdrop className={classes.backdrop} open={openModal} />
      <Dialog
        open={openModal}
        onClose={() => setOpen(false)}
        sx={{ mx: "auto" }}
        // classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          sx={{
            padding: "15px",
            width: "364px",
            backgroundColor: "white",
            position: "relative",
            borderRadius: "12px",
          }}
        >
          <CloseSharp
            onClick={() => setOpen(false)}
            sx={{
              width: "15px",
              height: "15px",
              color: "black",
              right: "14px",
              top: "13px",
              position: "absolute",
              cursor: "pointer",
            }}
          />
          <Box sx={{ color: "black" }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, textAlign: "center" }}
            >
              Pickup Proof Details
            </Typography>
            <Box
              sx={{
                backgroundColor: pickup.pickupEvidenceImage
                  ? "transparent"
                  : "#673C8E59",
                borderRadius: "12px",
                height: "115px",
                mt: "12px",
              }}
            >
              {pickup.pickupEvidenceImage && (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "12px",
                  }}
                  src={pickup.pickupEvidenceImage}
                  alt="proof-img"
                />
              )}
            </Box>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                textAlign: "center",
                color: "#673C8E",
                mt: "12px",
              }}
            >
              Pickup Image By Driver
            </Typography>
            <Box sx={{ mt: "20px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                Driver Pickup Notes
              </Typography>
              <Typography
                sx={{
                  px: "10px",
                  py: "8px",
                  fontSize: "12px",
                  color: "#797979",
                  border: "1px solid #CECECE",
                  borderRadius: "12px",
                  mt: "12px",
                }}
              >
                {pickup.drivernote}
              </Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PickupProofModal;
